import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import Select from 'react-select'
import ReactSwitch from "react-switch"
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import TipoFormularioSecuenciaPaso from './TipoFormularioSecuenciaPaso.js'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class TipoFormularioSecuenciaAbm extends Component {
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();

		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				nombre: '',
				descripcion: '',
				activo: true,
				movil_estado_origen: null,
				movil_estado_destino_aprobado: null,
				movil_estado_destino_descalificado: null,
				cantidad_maxima_intentos: '',
				items: [],
			},
			movil_estados: [],
			tipoFormularioOptions: [],
			errors: [],
			loading: false,
		};

		this.handleEstadoChange = this.handleEstadoChange.bind(this);
		this.handleInputFormChange = this.handleInputFormChange.bind(this);
		this.handleMovilEstadoChange = this.handleMovilEstadoChange.bind(this);
		this.handleAddItem = this.handleAddItem.bind(this);
		this.handleDeleteItem = this.handleDeleteItem.bind(this);
		this.handleChangeItem = this.handleChangeItem.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.formValidation = new FormValidation({
			component: this,
			validators: {
				'formData.nombre': (value) => Validator.notEmpty(value),
				'formData.movil_estado_origen': (value) => Validator.notEmpty(value),
				'formData.movil_estado_destino_aprobado': (value) => Validator.notEmpty(value),
				'formData.movil_estado_destino_descalificado': (value) => Validator.notEmpty(value),
				'formData.cantidad_maxima_intentos': (value) => Validator.intNumberGreaterOrEqualThan(value, 1, '1'),
				'formData.items': (value) => {
					let ids = Array.isArray(value) ? value.map((item) => item.tipo_formulario_id).filter((id) => id !== null && id !== undefined) : [];
					let sinDuplicados = ids.filter((id, index) => ids.indexOf(id) === index);
					let valid = Array.isArray(value) && value.length > 0 && value.every((item) => item.tipo_formulario_id) && ids.length === sinDuplicados.length;
					let message = '';
					if (!Array.isArray(value) || value.length === 0)
						message = 'Debe agregar al menos un checklist a la secuencia';
					else if (!value.every((item) => item.tipo_formulario_id))
						message = 'Todos los pasos deben tener un checklist seleccionado';
					else if (ids.length !== sinDuplicados.length)
						message = 'No se puede repetir el mismo checklist en distintos pasos';
					return { valid, message };
				},
			}
		});
	}

	initForm() {
		this.setState({ loading: true });
		let component = this;

		Promise.all([
			this.state.props.action !== 'ADD' ? this.ajaxHandler.getJson('/tipo-formulario-secuencia/' + this.state.props.match.params.id) : null,
			ConfigBusiness.get('moviles.estadosActivos'),
			this.ajaxHandler.getJson('/tipoformulario'),
		]).then((data) => {
			let formDataNew = data[0];
			let movil_estados = data[1] ? data[1].split(',').map((e) => ({ id: e, nombre: e })) : [];
			// Solo los checklists que se completan sobre un vehículo: uno sin vehículo nunca se enlaza a un intento y la secuencia no podría terminar.
			let tipoFormularioOptions = data[2] ? data[2].filter((tipoFormulario) => !!tipoFormulario.con_movil).map((tipoFormulario) => ({ value: tipoFormulario.id, label: tipoFormulario.nombre, descripcion: tipoFormulario.descripcion })) : [];
			component.setState({ movil_estados, tipoFormularioOptions });

			if (formDataNew) {
				formDataNew.items = formDataNew.items.map((item) => ({ tipo_formulario_id: item.tipo_formulario_id, orden: item.orden }));
				component.setState({ formData: formDataNew });
			} else {
				this.handleAddItem();
			}
		}).catch(function(error) {
			console.log(error);
			component.exit();
		}).finally(() => {
			this.setState({ loading: false });
		});
	}

	componentWillMount() {
		if ((Security.hasPermission('CHECKLIST_CONFIGURAR_SECUENCIA') && this.state.props.action === 'ADD') ||
			(Security.hasPermission('CHECKLIST_CONFIGURAR_SECUENCIA') && this.state.props.action === 'EDIT') ||
			(Security.hasPermission('CHECKLIST_LISTAR_SECUENCIA') && this.state.props.action === 'VIEW')) {
			this.ajaxHandler.subscribe(this);
			this.initForm();
		} else {
			this.setState({
				redirectTo: '/error'
			});
		}
	}

	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	handleEstadoChange(activo) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.activo = activo;
		this.setState({ formData: formDataCopy });
	}

	handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({ formData: formDataCopy });
	}

	handleMovilEstadoChange(field, value) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[field] = value;
		this.setState({ formData: formDataCopy });
	}

	handleAddItem() {
		if (this.state.formData.items.some((item) => !item.tipo_formulario_id)) return;
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.items.push({ tipo_formulario_id: null, orden: formDataCopy.items.length + 1 });
		this.setState({ formData: formDataCopy });
	}

	handleDeleteItem(index) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.items.splice(index, 1);
		this.setState({ formData: formDataCopy });
	}

	handleChangeItem(index, tipoFormularioId) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.items[index].tipo_formulario_id = tipoFormularioId;
		this.setState({ formData: formDataCopy });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.setState({ loading: true });
		let component = this;
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.items = formDataCopy.items.map((item, index) => ({ tipo_formulario_id: item.tipo_formulario_id, orden: index + 1 }));

		this.ajaxHandler.fetch('/tipo-formulario-secuencia' + (this.props.action === 'ADD' ? '' : '/' + formDataCopy.id), {
			method: this.props.action === 'ADD' ? 'POST' : 'PUT',
			body: JSON.stringify({ ...formDataCopy }),
		}).then((response) => {
			if (response.status !== 400) {
				component.exit();
			} else {
				response.json().then((data) => {
					this.setState({ errors: data.detalle });
				});
			}
			window.scrollTo(0, 0);
		}).catch((error) => {
			component.ajaxHandler.handleError(error);
		}).finally(() => {
			this.setState({ loading: false });
		});
	}

	handleCancel() {
		this.exit();
	}

	exit() {
		this.setState({ redirectTo: '/tipoformulariosecuencia' });
	}

	render() {
		this.formValidation.validate();
		let formData = this.state.formData;
		let validationState = this.formValidation.state;
		let disabled = this.props.action === 'VIEW';

		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				{this.state.loading && <Loading />}
				<div className="row">
					<div className="col-md-12">
						<div className="alert alert-danger" role="alert" hidden={this.state.errors.length === 0}>
							{this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])}/></li>)}
						</div>
						<form className="form form-horizontal" onSubmit={this.handleSubmit}>
							<div className="form-body">
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<h4 className="form-section">
												<i className="icon-home"></i><FormattedMessage id="tipoFormularioSecuenciaAbm.general_data.label_datos_generales" defaultMessage=" Datos Generales "/><div className="float-right" style={{fontSize:'14px'}}><FormattedMessage id="tipoFormularioSecuenciaAbm.general_data.campos_requeridos" defaultMessage="* campos requeridos"/></div>
											</h4>
											<div className="row">
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-4 label-control col-form-label" htmlFor="nombre">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.general_data.label_nombre" defaultMessage="Nombre de la secuencia *:"/>
														</label>
														<div className="col-md-8">
															<input disabled={disabled} type="text" className="form-control" id="nombre" name="nombre" value={formData.nombre} onChange={this.handleInputFormChange} />
															<div className="help-block text-danger field-message" hidden={validationState.formData.nombre.pristine || validationState.formData.nombre.valid}>{validationState.formData.nombre.message}</div>
														</div>
													</div>
												</div>
												<div className="col-md-6">
													<div className="form-group row align-items-center">
														<label className="col-md-4 label-control col-form-label" htmlFor="activo">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.general_data.label_activo" defaultMessage="Activo:"/>
														</label>
														<div className="col-md-8">
															<ReactSwitch
																onChange={this.handleEstadoChange}
																checked={formData.activo}
																id="activo"
																name="activo"
																disabled={disabled}
																offColor="#FF4961"
																onColor="#28D094"
															/>
														</div>
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-md-12">
													<div className="form-group row">
														<label className="col-md-2 label-control col-form-label" htmlFor="descripcion">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.general_data.label_descripcion" defaultMessage="Descripción:"/>
														</label>
														<div className="col-md-10">
															<textarea disabled={disabled} className="form-control" id="descripcion" name="descripcion" value={formData.descripcion} onChange={this.handleInputFormChange}></textarea>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<h4 className="form-section">
												<i className="icon-settings"></i><FormattedMessage id="tipoFormularioSecuenciaAbm.aplicacion.label_titulo" defaultMessage=" Aplicación de la secuencia "/>
											</h4>
											<div className="row">
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-5 label-control col-form-label" htmlFor="movil_estado_origen">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.aplicacion.label_estado_origen" defaultMessage="Aplica a vehículos en estado *:"/>
														</label>
														<div className="col-md-7">
															<Select
																options={this.state.movil_estados}
																valueKey="id"
																labelKey="nombre"
																value={formData.movil_estado_origen}
																onChange={(e) => this.handleMovilEstadoChange('movil_estado_origen', e ? e.id : null)}
																disabled={disabled}
																multi={false}
															/>
															<div className="help-block text-danger field-message" hidden={validationState.formData.movil_estado_origen.pristine || validationState.formData.movil_estado_origen.valid}>{validationState.formData.movil_estado_origen.message}</div>
														</div>
													</div>
												</div>
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-5 label-control col-form-label" htmlFor="cantidad_maxima_intentos">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.aplicacion.label_cantidad_maxima_intentos" defaultMessage="Cantidad máxima de intentos *:"/>
														</label>
														<div className="col-md-7">
															<input disabled={disabled} type="number" min="1" className="form-control" id="cantidad_maxima_intentos" name="cantidad_maxima_intentos" value={formData.cantidad_maxima_intentos} onChange={this.handleInputFormChange} />
															<div className="help-block text-danger field-message" hidden={validationState.formData.cantidad_maxima_intentos.pristine || validationState.formData.cantidad_maxima_intentos.valid}>{validationState.formData.cantidad_maxima_intentos.message}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<h4 className="form-section">
									<i className="icon-list"></i><FormattedMessage id="tipoFormularioSecuenciaAbm.items.label_titulo" defaultMessage=" Checklists de la Secuencia "/>
								</h4>
								<p className="text-muted"><FormattedMessage id="tipoFormularioSecuenciaAbm.items.help_sin_orden" defaultMessage="Los checklists se pueden hacer en cualquier orden. Se aprueba la secuencia cuando están todos aprobados."/></p>
								<div className="help-block text-danger field-message mb-1" hidden={validationState.formData.items.pristine || validationState.formData.items.valid}>{validationState.formData.items.message}</div>

								{!this.state.loading &&
									<div>
										{formData.items.map((item, index) => (
											<TipoFormularioSecuenciaPaso
												key={index}
												index={index}
												paso={item}
												disabled={disabled}
												handleChange={this.handleChangeItem}
												handleDelete={this.handleDeleteItem}
												idsUsados={formData.items.filter((i) => i !== item).map((i) => i.tipo_formulario_id).filter((id) => id !== null && id !== undefined)}
												tipoFormularioOptions={this.state.tipoFormularioOptions}
											/>
										))}
									</div>
								}

								{!disabled &&
									<div className="mb-2">
										<button type="button" className={"btn " + (formData.items.some((item) => !item.tipo_formulario_id) ? "btn-secondary" : "btn-success")} onClick={this.handleAddItem} disabled={formData.items.some((item) => !item.tipo_formulario_id)}>
											<i className="fa fa-plus"></i><FormattedMessage id="tipoFormularioSecuenciaAbm.items.button_add" defaultMessage=" Agregar Checklist a la Secuencia"/>
										</button>
									</div>
								}

								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<h4 className="form-section">
												<i className="icon-check-circle"></i><FormattedMessage id="tipoFormularioSecuenciaAbm.accion_final.label_titulo" defaultMessage=" Acción Final de la Secuencia "/>
											</h4>
											<div className="row">
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-5 label-control col-form-label" htmlFor="movil_estado_destino_aprobado">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.accion_final.label_estado_destino_aprobado" defaultMessage="Si se aprueban todos los checklists, cambiar estado del vehículo a *:"/>
														</label>
														<div className="col-md-7">
															<Select
																options={this.state.movil_estados}
																valueKey="id"
																labelKey="nombre"
																value={formData.movil_estado_destino_aprobado}
																onChange={(e) => this.handleMovilEstadoChange('movil_estado_destino_aprobado', e ? e.id : null)}
																disabled={disabled}
																multi={false}
															/>
															<div className="help-block text-danger field-message" hidden={validationState.formData.movil_estado_destino_aprobado.pristine || validationState.formData.movil_estado_destino_aprobado.valid}>{validationState.formData.movil_estado_destino_aprobado.message}</div>
														</div>
													</div>
												</div>
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-5 label-control col-form-label">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.accion_final.label_rechazo_intermedio" defaultMessage="Si se rechaza un checklist antes del final:"/>
														</label>
														<div className="col-md-7 col-form-label text-muted">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.accion_final.descripcion_rechazo_intermedio" defaultMessage="Consume 1 intento y reinicia la secuencia desde el paso 1 (si quedan intentos disponibles)"/>
														</div>
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-5 label-control col-form-label" htmlFor="movil_estado_destino_descalificado">
															<FormattedMessage id="tipoFormularioSecuenciaAbm.accion_final.label_estado_destino_descalificado" defaultMessage="Si se agotan los intentos máximos, cambiar estado del vehículo a *:"/>
														</label>
														<div className="col-md-7">
															<Select
																options={this.state.movil_estados}
																valueKey="id"
																labelKey="nombre"
																value={formData.movil_estado_destino_descalificado}
																onChange={(e) => this.handleMovilEstadoChange('movil_estado_destino_descalificado', e ? e.id : null)}
																disabled={disabled}
																multi={false}
															/>
															<div className="help-block text-danger field-message" hidden={validationState.formData.movil_estado_destino_descalificado.pristine || validationState.formData.movil_estado_destino_descalificado.valid}>{validationState.formData.movil_estado_destino_descalificado.message}</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">
											<div className="text-cd text-right">
												{!disabled && (
													<button type="submit" className="btn btn-primary mr-1" disabled={!validationState.form.valid}>
														<i className="fa fa-check-circle"></i><FormattedMessage id="tipoFormularioSecuenciaAbm.button_finish.guardar" defaultMessage=" Guardar"/>
													</button>
												)}
												<button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
													<i className="fa fa-times-circle"></i> {disabled ? this.props.intl.formatMessage({ id: 'tipoFormularioSecuenciaAbm.button_finish.volver', defaultMessage: 'Volver' }) : this.props.intl.formatMessage({ id: 'tipoFormularioSecuenciaAbm.button_finish.cancelar', defaultMessage: 'Cancelar' })}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default injectIntl(TipoFormularioSecuenciaAbm);
